/* eslint-disable no-duplicate-imports, no-unused-vars, react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, Fragment, Suspense, useRef } from "react";
import { ListItem } from "@mui/material";
import p2Alerts from '../../../assets/images/P2alerts.svg';
import graph from "../../../assets/images/graph-new.svg";
import Filters from "../../../assets/images/filters.svg";

import Slider from "../../../assets/images/sliders 1.svg";
import resetBtn from "../../../assets/images/resetBtn.png";
import vector from "../../../assets/images/Vector.svg";
import styles from "./manpower.module.css";
import { styled } from "@mui/system";
import { useMsal } from "@azure/msal-react";
import AlertRmpmKpi from "../../components/Cards/AlertKPI";
import Multiselectwithsearchinput from "../../components/dropdown/MultiSelectWithInput";
import SnackBarMessage from "Samarth Module/components/snackbar/snackbar";
import { getWeekDataForTable, getParameterData, getGraphData } from "Samarth Module/api/ManpowerShortageAPI";
import OverflowMenu from "Samarth Module/components/overflowMenu/OverflowMenu";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { scheduleCleanup, getFilterDetails } from "utils/generateFilterObject";
import { transformFilters } from "utils/transformFilters";
import ExportLoader from "Samarth Module/components/snackbar/exportLoader";
import CustomiseColumns from "Samarth Module/components/drawers/CustomiseColumns";
import MoreFilters from "Samarth Module/components/drawers/moreFilters";
import { tableWeekColumns, parameterTableColumns, initialGraph } from './manpowerConfig';

import ChatBot from "Samarth Module/components/chatbot/ChatBot";
import { usePageTracking } from "utils/userPageTracking";
const ManpowerParametersTable = React.lazy(() => import("Samarth Module/components/table/manpowerParametersTable"));
const BarChartManpowerShortage = React.lazy(() => import("Samarth Module/components/barAndLineComboChart/barChartManpowerShortage"));

const getParameterRowsByWeek = (parameterData = []) => {
  if (!parameterData.length) {
    return [];
  }

  const parameters = Object.keys(parameterData[0]).filter((par) => par !== "week");
  const weeks = [...new Set(parameterData.map((item) => item.week))].sort((a, b) => a - b);

  const weeklyDataLookup = {};
  for (const item of parameterData) {
    weeklyDataLookup[item.week] = item;
  }

  const result = [];
  for (const param of parameters) {
    const row = { Parameters: param };
    for (const week of weeks) {
      row[`Wk ${week}`] = weeklyDataLookup[week]?.[param] || 0;
    }
    result.push(row);
  }

  return result;
};

const getMpiCellBgColor = (numericValue) => {
  if (numericValue === null || numericValue === undefined || Number.isNaN(numericValue)) {
    return "#FF9998";
  }

  const percentageValue = numericValue * 100;
  if (percentageValue >= 0 && percentageValue <= 90) {
    return "#FF9998";
  }
  if (percentageValue > 90) {
    return "#A3E1D2";
  }

  return undefined;
};

const getQtyAtRiskCellBgColor = (numericValue) => {
  if (numericValue === null || numericValue === undefined || Number.isNaN(numericValue)) {
    return "#FF9998";
  }

  if (numericValue >= 0 && numericValue <= 400) {
    return "#FF9998";
  }
  if (numericValue > 400 && numericValue <= 650) {
    return "#FFEC9A";
  }
  if (numericValue > 650) {
    return "#A3E1D2";
  }

  return undefined;
};


const Manpowershortage = () => {
    const alertType = "Manpower Shortage";
    //get login user details
    const { accounts } = useMsal();
    const activeAccount = accounts[0] || null;
    //kpi tiles initilize
    const [kpiData, setKpiData] = useState([
        {
            label: "Man power shortage alerts",
            img: p2Alerts,
            value: 0
        },
        {
            label: "Predictive production loss",
            img: graph,
            value: 0
        },
        {
            label: "Predicted accuracy",
            values: {
                "Week N-4": 0,
                "Week N-3": 0,
                "Week N-2": 0,
                "Week N-1": 0
            }
        },
    ]);
    //state variable
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: "",
        type: "error",
    });
    const [filterObjectOption, setFilterObjectOption] = useState({});
    const [changeFilterObject, setChangeFilterObject] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const [isFilterLoadingPT, setIsFilterLoadingPT] = useState(false);
    const [isPtableLoading, setIsPtableLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
    const [parameterTableData, setParameterTableData] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [totalEmpPerWeek, setTotalEmpPerWeek] = useState(0);
    const [capacityPerWeek, setCapacityPerWeek] = useState(0);
    const [plantRunningDays, setPlantRunningDays] = useState(0);
    const [exportLoader] = useState(false);
    const [moreFilterLoader, setMoreFilterLoader] = useState(false);
    const [customiseLoader, setCustomiseLoader] = useState(false);
    const [afterAddRows, setAfterAddRows] = useState(0);
    const clearFiltersRef = useRef(false);

    usePageTracking(alertType);

    //api call for table data, column, filter data on page load
    // clean filter data
    useEffect(() => {
        scheduleCleanup();
    }, []);
    // API call for get filter details
    const getFilterOptionDetails = useCallback(async () => {
        const resData = await getFilterDetails(alertType, 'Detailed view');
        setFilterObjectOption(resData?.data?.filters || {});
    }, []);
    useEffect(() => {
        getFilterOptionDetails();
    }, [getFilterOptionDetails]);

    const generatePayload = useCallback(() => {
        const shouldClearFilters = clearFiltersRef.current;
        clearFiltersRef.current = false;
        
        const transformedFilters = transformFilters(changeFilterObject);
        return {
            email: activeAccount.username,
            type: alertType,
            role: activeAccount?.idTokenClaims?.roles,
            filterData: transformedFilters,
            clearFilters: shouldClearFilters
        };
    }, [activeAccount, changeFilterObject, afterAddRows]);
    const fetchTableData = useCallback(async () => {
        changeFilterObject?.length > 0 ? setIsFilterLoading(true) : setIsTableLoading(true);
        try {
            const payload = generatePayload();
            const apiResponseData = await getWeekDataForTable(payload);
            setTableData(apiResponseData?.alertDetails || []);
            setTableColumns(apiResponseData?.defaultColumns || []);
            setFilterData(apiResponseData?.filters || []);
            const resKpiData = apiResponseData?.kpiData;
            if (resKpiData?.length > 0) {
                const initialKpiData = [...kpiData];
                const tempKpiData = initialKpiData?.map(item => {
                    const kupdated = resKpiData?.find(u => u.label === item.label);
                    return kupdated ? { ...item, ...kupdated } : item;
                });
                setKpiData(tempKpiData);
            }
            setIsTableLoading(false);
            setIsFilterLoading(false);
        } catch (error) {
            setIsTableLoading(false);
            setIsFilterLoading(false);
            setSnackBarObject({ snackbarOpen: true, message: error.message, type: "error" });
        }
    }, [generatePayload]);
    useEffect(() => {
        fetchTableData();
    }, [fetchTableData])

    //api call for Graph data on page load
    const fetchGraphData = useCallback(async () => {
        try {
            const payload = generatePayload();
            const apiResponseData = await getGraphData(payload);
            const resChartData = apiResponseData?.chartData;
            if (resChartData?.length > 0) {
                const initialChartData = initialGraph;
                const graphData = initialChartData?.map((row) => {
                    return { name: row?.name, planProduction: getCountData(row?.week, resChartData, 'planProduction'), predictedProduction: getCountData(row?.week, resChartData, 'predictedProduction') }
                });
                setChartData(graphData);
            } else {
                setChartData(initialGraph);
            }
        } catch (error) {
            handleError(error?.message);
        }
    }, [generatePayload]);
    useEffect(() => {
        fetchGraphData();
    }, [fetchGraphData])

    //api call for Parameter table data on page load
    const fetchParameterTableData = useCallback(async () => {
        changeFilterObject?.length > 0 ? setIsFilterLoadingPT(true) : setIsPtableLoading(true);
        try {
            const payload = generatePayload();
            const apiResponseData = await getParameterData(payload);
            const pData = apiResponseData?.parameterData || [];
            if (pData?.length > 0) {
          const result = getParameterRowsByWeek(pData);
                setParameterTableData(result || []);
            } else {
                setParameterTableData([]);
            }
            setTotalEmpPerWeek(apiResponseData?.totalEmpPerWeek || 0);
            setCapacityPerWeek(apiResponseData?.capacityPerWeek || 0);
            setPlantRunningDays(apiResponseData?.plantRunningDays || 0);
            setIsPtableLoading(false);
            setIsFilterLoadingPT(false);
        } catch (error) {
            setIsPtableLoading(false);
            setIsFilterLoadingPT(false);
            handleError(error?.message);
        }
    }, [generatePayload]);
    useEffect(() => {
        fetchParameterTableData();
    }, [fetchParameterTableData])


    const handleMultiSelectChange = useCallback((label, values) => {
        //onchange API call
        const filterDataobj = [...filterData];
        const tempData = filterDataobj?.map(filter => filter.label === label ? { ...filter, selectedData: values } : filter);
        
        // Check if there are any selected filters
        const hasSelection = tempData.some((filter) => {
            const selected = filter?.selectedData;
            if (Array.isArray(selected)) return selected.length > 0;
            if (typeof selected === 'string') return selected.trim().length > 0;
            return selected !== undefined && selected !== null;
        });
        
        clearFiltersRef.current = !hasSelection;
        setChangeFilterObject(tempData);

        setFilterData(prev =>
            prev.map(filter => filter.label === label ? { ...filter, selectedData: values } : filter)
        );
    }, [filterData]);
    const resetFilter = useCallback(() => {
        clearFiltersRef.current = true;
        const filterDataobj = [...filterData];
        const tempData = filterDataobj?.map(filter => ({ ...filter, selectedData: [] }));
        setChangeFilterObject(tempData);
        setFilterData(prev =>
            prev.map(filter => ({ ...filter, selectedData: [] }))
        );
    }, [filterData]);
    const handleCustomizeDrawer = useCallback(() => {
        setCustomiseLoader(prev => !prev);
    }, []);

    const handleFilterDrawer = useCallback(() => {
        setMoreFilterLoader(prev => !prev);
    }, []);
    const handleFilterDrawerClose = useCallback(() => {
        setMoreFilterLoader(false);
    }, []);
    const handleFiltersSaved = useCallback((updatedFilters) => {
        // Check if there are any selected filters
        const hasSelection = updatedFilters.some((filter) => {
            const selected = filter?.selectedData;
            if (Array.isArray(selected)) return selected.length > 0;
            if (typeof selected === 'string') return selected.trim().length > 0;
            return selected !== undefined && selected !== null;
        });
        
        clearFiltersRef.current = !hasSelection;
        setChangeFilterObject(updatedFilters);
        setAfterAddRows((prev) => prev + 1);
    }, []);
    const columnCustomization = useCallback((list) => {
        setTableColumns(list);
        setCustomiseLoader(false);
    }, []);
    //Error handaling. | display Alert message
    const handleError = useCallback((message) => {
        setSnackBarObject({ snackbarOpen: true, message, type: "error" });
    }, []);

    //Close Alert message
    const closeSnackbar = useCallback(() => {
        setSnackBarObject((prev) => ({ ...prev, snackbarOpen: false }));
    }, []);

    const getCountData = (week, data, key) => {
        const total = data?.filter(row => week === row?.week)?.reduce((sum, item) => sum + (item[key] || 0), 0);
        return total?.toFixed(0);
    }
    const getCellBgColor = (value, colName) => {
        const numericValue = Number.parseFloat(value);
      if (colName === 'Days to action') {
            return "#F5F5F5";
        }

      if (colName === 'MPI') {
        return getMpiCellBgColor(numericValue);
      }

      if (colName === 'Qty at risk') {
        return getQtyAtRiskCellBgColor(numericValue);
      }

      return "#FFFFFF";
    };
    const getFormatValue = (value, colName) => {
        if (colName === 'MPI') {
            return `${(value * 100)?.toFixed(1)}%`;
        } else if (colName === 'Qty at risk') {
            return value ? `${(value)?.toFixed(1)} T` : 0;
        } else {
            return value;
        }
    };
    const getFormatQtyAtRiskValue = (qtyAtRisk, mpi) => {
        const numericMpiValue = Number.parseFloat(mpi) * 100;
        if (numericMpiValue >= 90) {
            return '0';
        } else {
            return qtyAtRisk ? `${(qtyAtRisk)?.toFixed(0)} T` : '0';
        }
    };
    const handleSort = (key) => {
        setSortConfig((prev) => ({
            key,
            direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
        }));
    };
    // styled
    const StyledTableCell = styled(TableCell)(({ theme, value, colname }) => ({
        "&.MuiTableCell-head": {
            fontFamily: "Unilever Shilling",
            backgroundColor: "var(--primany-table-header-color)",
            color: "#fff",
            textAlign: "center",
            padding: "5px",
            fontSize: "12px",
            fontWeight: 600,
            outline: "1px solid #EAECF0",
            whiteSpace: "nowrap",
        },
        "&.MuiTableCell-body": {
            fontFamily: "Unilever Shilling",
            fontSize: "12px",
            fontWeight: 400,
            padding: "5px",
            color: "#2B2B2B",
            border: "1px solid #EAECF0",
            textAlign: "center",
            whiteSpace: "nowrap",
            backgroundColor: getCellBgColor(value, colname),
        },
    }));

    const StyledTableRow = styled(TableRow)({
        backgroundColor: "#FFFFFF !important"
    });

    const StyledTableSubHeaderCell = styled(TableCell)({
        "&.MuiTableCell-head": {
            fontFamily: "Unilever Shilling",
            backgroundColor: "#F5F5F5",
            color: "var(--black-color)",
            textAlign: "center",
            padding: "2px",
            fontSize: "12px",
            fontWeight: 600,
            outline: "1px solid #DBDBDB",
            borderBottom: "none",
            whiteSpace: "nowrap",
        },
    });
    const StyledLeftEmptyCell = {
        backgroundColor: "#FFFFFF !important",
        outline: "none !important",
        borderLeft: "1px solid #EAECF0 !important",
        borderBottom: "1px solid #EAECF0 !important"
    };

    // Determine table body content based on loading and data states
    const hasTableData = tableData.length > 0 && tableColumns?.length > 0;
    const loadingTableBodyContent = (
        <StyledTableRow>
            <StyledTableCell
                colSpan={
                    tableColumns?.filter((a) => a.visibility === true)
                        ?.length + 8
                }
                sx={{ whiteSpace: "nowrap", minWidth: "100px" }}
            >
                Loading...
            </StyledTableCell>
        </StyledTableRow>
    );

    const dataTableBodyContent = hasTableData
        ? tableData.map((alert, index) => (
            <StyledTableRow key={`bc${index * 2}`}>
                {tableColumns
                    ?.filter((a) => a.visibility === true)
                    ?.map((col, colIdx) => (
                        <StyledTableCell
                            value={alert[col.label]}
                            colname={col?.label}
                            key={`${index + colIdx}`}
                        >
                            {alert[col?.label]}
                        </StyledTableCell>
                    ))}
                {tableWeekColumns
                    ?.filter((a) => a.visibility === true)
                    ?.map((col, colIdx) => (
                        <Fragment key={`f${index + colIdx}`}>
                            <StyledTableCell
                                value={alert[`${col.label}_MPI`]}
                                colname={"MPI"}
                                key={`bwk${index + colIdx}`}
                            >
                                {getFormatValue(
                                    alert[`${col.label}_MPI`],
                                    "MPI",
                                )}
                            </StyledTableCell>
                            <StyledTableCell
                                value={alert[`${col.label}_MPI`]}
                                colname={"MPI"}
                                key={`bwkq${index + colIdx}`}
                            >
                                {getFormatQtyAtRiskValue(
                                    alert[`${col.label}_Qty_at_risk`],
                                    alert[`${col.label}_MPI`],
                                )}
                            </StyledTableCell>
                        </Fragment>
                    ))}
            </StyledTableRow>
        ))
        : null;

    const noDataTableBodyContent = (
        <StyledTableRow>
            <StyledTableCell
                colSpan={
                    tableColumns?.filter((a) => a.visibility === true)
                        ?.length + 8
                }
                sx={{ whiteSpace: "nowrap", minWidth: "100px" }}
            >
                Data not available...
            </StyledTableCell>
        </StyledTableRow>
    );

    let tableBodyContent;
    if (isFilterLoading) {
        tableBodyContent = loadingTableBodyContent;
    } else if (hasTableData) {
        tableBodyContent = dataTableBodyContent;
    } else {
        tableBodyContent = noDataTableBodyContent;
    }

    return (
      <Fragment>
        {/* KPI Card Show */}
        <div className={styles.kpiContainer}>
          <AlertRmpmKpi KPIObj={kpiData} type={alertType} />
        </div>
        <div className={styles.mainContainer}>
          <div className={styles.rmpmTableBody}>
            {isTableLoading ? (
              <div className={styles.loaderContainer}>
                <CircularProgress />
              </div>
            ) : (
              <Fragment>
                <div className={styles.manpowerFilterDiv}>
                  <div className={styles.fstDiv}>
                    {filterData?.length > 0 &&
                      filterData
                        ?.filter((filter) => filter.isFavourite)
                        ?.map((filter) => (
                          <ListItem
                            key={filter.label}
                            className={styles.listCustomClass}
                          >
                            <Multiselectwithsearchinput
                              key={filter.label}
                              label={filter.label}
                              options={filterObjectOption[filter.label]}
                              filterValues={filter.selectedData}
                              handleFilter={handleMultiSelectChange}
                              disabled={false}
                              isLabelShow={true}
                            />
                          </ListItem>
                        ))}
                    </div>
                    <div className={styles.restMorediv}>
                      <button
                        type="button"
                        onClick={resetFilter}
                        aria-label="Reset Filters"
                        style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                      >
                        <img
                          src={resetBtn}
                          alt="Reset Filters"
                          style={{ cursor: "pointer", marginRight: "5px" }}
                        />
                      </button>
                      <OverflowMenu
                        menuItems={[
                          {
                            label: "More Filters",
                          icon: Filters,
                          onClick: handleFilterDrawer,
                        },
                        {
                          label: "Customise",
                          icon: Slider,
                          onClick: handleCustomizeDrawer,
                        },
                        // {
                        //     label: 'Export',
                        //     icon: Excel,
                        //     onClick: exportToExcel,
                        // },
                      ]}
                    />
                  </div>
                </div>
                <TableContainer
                  className={styles.table}
                  style={{ height: "calc(100vh - 560px)", minHeight: "174px" }}
                >
                  <Table size="small" stickyHeader>
                    <TableHead>
                      {/* Main header row */}
                      {tableColumns?.length > 0 ? (
                        <Fragment>
                          <TableRow>
                            {tableColumns
                              ?.filter((a) => a.visibility === true)
                              ?.map((col, index) => {
                                return (
                                  <StyledTableCell
                                    key={`mainW-${col.label}-${index}`}
                                    onClick={() =>
                                      col.sortable && handleSort(col.label)
                                    }
                                    sx={{
                                      cursor: col.sortable
                                        ? "pointer"
                                        : "default",
                                      position: "sticky",
                                      top: 0,
                                      zIndex: 2,
                                    }}
                                  >
                                    <div className={styles.sortIcon}>
                                      {col.label}
                                      {col.sortable &&
                                        sortConfig.key === col.label && (
                                          <img
                                            src={vector}
                                            alt="sort icon"
                                            width="14px"
                                            height="14px"
                                            style={{ marginLeft: "4px" }}
                                          />
                                        )}
                                    </div>
                                  </StyledTableCell>
                                );
                              })}
                            {/* Statick Column */}
                            {tableWeekColumns
                              ?.filter((a) => a.visibility === true)
                              ?.map((col, index) => {
                                return (
                                  <StyledTableCell
                                    key={`mainW-${col.label}-${index}`}
                                    colSpan={2}
                                    sx={{
                                      position: "sticky",
                                      top: 0,
                                      zIndex: 2,
                                    }}
                                  >
                                    {col.DisplayLabel}
                                  </StyledTableCell>
                                );
                              })}
                          </TableRow>
                          <TableRow>
                            <StyledTableSubHeaderCell
                              sx={{
                                ...StyledLeftEmptyCell,
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                              colSpan={
                                tableColumns?.filter(
                                  (a) => a.visibility === true,
                                )?.length
                              }
                            ></StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              Qty at risk
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              Qty at risk
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              Qty at risk
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              MPI
                            </StyledTableSubHeaderCell>
                            <StyledTableSubHeaderCell
                              sx={{
                                position: "sticky",
                                top: "36px", // Height of the main header
                                zIndex: 1,
                              }}
                            >
                              Qty at risk
                            </StyledTableSubHeaderCell>
                          </TableRow>
                        </Fragment>
                      ) : (
                        <Fragment>
                          <TableRow>
                            <StyledTableCell
                              sx={{
                                backgroundColor:
                                  "var(--primany-table-header-color)",
                              }}
                            >
                              No columns available...
                            </StyledTableCell>
                          </TableRow>
                        </Fragment>
                      )}
                    </TableHead>
                    <TableBody>
                      {tableBodyContent}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Fragment>
            )}
            <div className={styles.alertInsigtText}>
              <span>Alert insights</span>
            </div>
            <div className={styles.manpowerContainer}>
              <div className={styles.manpowerDivs}>
                <span className={styles.PPLoss}>
                  Predictive Production Trend
                </span>
                <div className={styles.manpowerSubContainer}>
                  <Suspense fallback={<div>Data loading...</div>}>
                    <BarChartManpowerShortage chartData={chartData} />
                  </Suspense>
                </div>
              </div>
              <div className={styles.manpowerDivs}>
                <Stack
                  direction={{
                    xs: "column",
                    sm: "column",
                    md: "column",
                    lg: "row",
                  }}
                  spacing={1}
                >
                  <Chip
                    label={
                      <>
                        Total number of employees per day :{" "}
                        <strong>{totalEmpPerWeek}</strong>
                      </>
                    }
                    className={styles.chips}
                    size="small"
                  />
                  <Chip
                    label={
                      <>
                        Overall site capacity per week :{" "}
                        <strong>{capacityPerWeek?.toFixed(0)}</strong>
                      </>
                    }
                    className={styles.chips}
                    size="small"
                  />
                  <Chip
                    label={
                      <>
                        Plant running days :{" "}
                        <strong>{plantRunningDays?.toFixed(0)}</strong>
                      </>
                    }
                    className={styles.chips}
                    size="small"
                  />
                </Stack>
                {isPtableLoading ? (
                  <div className={styles.ploaderContainer}>
                    <CircularProgress />
                  </div>
                ) : (
                  <Suspense fallback={<div>Data loading...</div>}>
                    <ManpowerParametersTable
                      columns={parameterTableColumns}
                      data={parameterTableData}
                      isFilter={isFilterLoadingPT}
                    />
                  </Suspense>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Alert message show */}
        {snackBarObject.snackbarOpen && (
          <SnackBarMessage
            type={snackBarObject.type}
            snackbarMessage={snackBarObject.message}
            snackbarOpen={snackBarObject.snackbarOpen}
            setSnackbarOpen={closeSnackbar}
          />
        )}
        {/* More Filters */}
        {moreFilterLoader && (
          <MoreFilters
            anchor="right"
            filterDrawer={moreFilterLoader}
            handleFilterDrawer={handleFilterDrawerClose}
            rmpmFilters={filterData}
            setRmpmFilters={(filters) => setFilterData(filters)}
            username={activeAccount.username}
            type={alertType}
            options={filterObjectOption}
            onFiltersSaved={handleFiltersSaved}
          />
        )}
        {/* customise column */}
        {customiseLoader && (
          <CustomiseColumns
            anchor="right"
            columns={tableColumns}
            isOpen={customiseLoader}
            handleCustomizeDrawer={handleCustomizeDrawer}
            columnCustomization={columnCustomization}
            username={activeAccount.username}
            type={alertType}
          />
        )}
        {/* export loader */}
        {exportLoader && <ExportLoader type={'Manpower Shortage'}/>}
        <ChatBot />
      </Fragment>
    );
};
export default Manpowershortage;